import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Input } from '../../../../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makePutRequest } from '../../../../../../utils/api'
import urls from '../../../../../../utils/urls'
import { convertToMuiDate } from '../../../../../../utils/helpers'

export default function EditOperationForm({ setOperations, params, operations, setSelected }) {
  const [open, setOpen] = useState(true)

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      immobilier: params[0].immobilier,
      id: params[0].id,
      date_value: params[0].date_value ? convertToMuiDate(params[0].date_value) : '',
      market_value: params[0].market_value,
    },
  })

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelected(false)
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }

    const response = await makePutRequest(
      urls.crudImmoValueOperations + `${data.id}/`,
      payload,
      {},
      true,
    )
    if (response.status === 200) {
      let id = response.data.id
      const filteredOperations = operations.results.filter((v) => v.id !== id)
      const updatedOperations = [...filteredOperations, { ...response.data }].sort((a, b) =>
        a.id > b.id ? 1 : -1,
      )

      setOperations((operations) => ({
        ...operations,
        results: updatedOperations,
      }))

      handleClose()
    }
  }

  return (
    <>
      {/* <CustomButton onClick={handleClickOpen}>créer</CustomButton> */}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle>Ajout VHkm</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="date_value"
              label="Date"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="market_value"
              label="Valeur"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
